rdefine('app/events/events', ['backbone'], function(Backbone) {
    var DateModel = Backbone.Ribs.Model.extend({
        defaults:{
            id:'',
            active:false,
            times:[]
        },
        addTime:function(time) {
            var times = this.get('times') || [];
            times.push(time);
            this.set('times',times);
            this.collection.trigger('times');
            this.trigger('change:times');
            console.log('add time',time);
        },
        removeTime: function(remove) {
            var times = this.get('times') || [];
            times = _.reduce(times,function(times, time) {
                if(time.from !== remove.from && time.end !== remove.end) {
                    times.push(time);
                }
                return times;
            },[]);
            this.set('times',times);
            this.collection.trigger('times');
            console.log('remove time',remove);
        },
        updateTime: function(from,to) {
            console.log("update time", from, to);
            var times = this.get('times') || [];
            times = _.reduce(times, function(times, time) {
                if(time.from === from.from && time.end === from.end) {
                    times.push(to);
                }else {
                    times.push(time);
                }
                return times;
            },[]);
            this.set('times',times);
            this.collection.trigger('times');
        }
    });

    return Backbone.Ribs.Collection.extend({
        model:DateModel,
        initialize:function(options) {
            console.log("EVents INIT");
        },
        isPresented: function(date) {
            return this.findWhere({id:date});
        },
        isPresentedAndActive: function(date) {
            var m = this.isPresented(date);
            return m ? m.get('active') : false;
        },
        getormake:function(date) {
            var model = this.isPresented(date);
            if(!model) {
                model = new DateModel({id:date});
                this.add(model);
            }
            return model;
        },
        enable: function(date) {
            console.log('enable',date);
            var model = this.isPresented(date);
            if(!model) {
                model = new DateModel({id:date});
                this.add(model);
            }
            model.set({active:true});
            this.trigger('times');
            return model;
        },
        disable: function(date) {
            console.log('disable',date);
            var model = this.isPresented(date);
            if(!model) {
                model = new DateModel({id:date});
                this.add(model);
            }
            model.set({active:false});
            this.trigger('times');
            return model;
        }
    });
});